import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap";
import Select from "react-select";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { AgGridReact, reactCellRendererFactory } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-enterprise";
import {
  getAssetsSchemas,
  getContractSchemas,
  getEpcSchemas,
  getSchemas,
  deleteSchemas
} from "../../../store/actions";
import Modal from 'react-responsive-modal';

import ModalComp from "./Modal";

class Tables extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteModalOpen: false,
      deleteSchemaId: -1,
      showDeleteIcon: true,
      sowDeleteModal:false,
      showmodal: false,
      select: {value:'active',label:'Active'},
      columnDefs: [
        { headerName: "Name", field: "name", width: 300 },
        { headerName: "Creation Date", field: "createDate", width: 300 },
        {
          headerName: "Api version created with",
          field: "version",
          width: 300
        },
        {
          headerName: "Action",
          field: "action",
          width: 300,
          cellRenderer: "deleteRenderer",
          cellRendererParams: {
            onDelete: id => {
              this.setState({
                deleteModalOpen:true,
                deleteSchemaId:id,
              });
            }
          }
        }
      ],
      context: { componentParent: this },

      frameworkComponents: {
        deleteRenderer: function(params) {

          return  (
            <div>
              <ul className="list-actions">
                <li>
                  {params.agGridReact.props.showDeleteIcon && (params.data.used ? (
                      <i
                          className="btn-delete fa fa-minus-circle fa-lg mr-2"
                          onClick={() => params.onDelete(params.data.id)}
                      />
                  ) : (
                      <i
                          className="btn-delete fa fa-trash fa-lg mr-2"
                          onClick={() => params.onDelete(params.data.id)}
                      />
                  ))}
                  |
                </li>
                <li>
                  <Link to={`/asset-schemas/edit-schema/${params.data.id}`}>
                    <i className="btn-edit fa fa-pencil fa-lg" />
                  </Link>
                </li>
              </ul>
            </div>
          );
        }
      },
      rowData: []
    };
    this.onGridReady = this.onGridReady.bind(this);
  };

  toggle = () => {
    this.setState({
      showmodal: false
    });
  };

  componentDidMount() {
    this.props.getAssetsSchemas();
    this.props.getContractSchemas();
    this.props.getEpcSchemas();
  }

  onRemoveSelected = async id => {
    let selectedData = this.gridApi.getSelectedRows();
    const res = await this.props.deleteSchemas(id);
    res &&
      res.payload.status >= 200 && res.payload.status <= 206 &&
      this.gridApi.updateRowData({ remove: selectedData });
  };

  async onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    await this.props.getSchemas();
    const rowData = [];
    this.props.allSchemas &&
      this.props.allSchemas.schemas &&
      this.props.allSchemas.schemas.results.map(data => {
        let obj = {
          name: data.name,
          createDate: moment(data.created_at).format("DD-MM-YYYY"),
          version: data.version,
          id: data.id,
          used: data.used,
          props: this.props.history
        };
        rowData.push(obj);
      });

    this.setState({ rowData });
  }

  handleSelect = async selectedOption => {
    if(selectedOption.value !== this.state.select.value ){
      this.setState({ select: selectedOption });

      if (selectedOption.value === "archive") {
        await this.props.getSchemas("archive");
        this.setState({showDeleteIcon:false});
      } else {
        await this.props.getSchemas();
        this.setState({showDeleteIcon:true});

      }
      const rowData = [];
      this.props.allSchemas.schemas &&
      this.props.allSchemas.schemas.results.map(data => {
        let obj = {
          name: data.name,
          createDate: moment(data.created_at).format("DD-MM-YYYY"),
          version: "1.0",
          id: data.id,
          used: data.used,
          props: this.props.history
        };
        rowData.push(obj);
      });
      this.setState({ rowData });
      this.gridApi.updateRowData({ update: rowData });
    }
  };

  render() {
    const options = [
      {
        value: "active",
        label: "Active"
      },
      {
        value: "archive",
        label: "Archive"
      }
    ];

    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <div>
                  <span style={{ float: "left", display: "inline" }}>
                    Asset Schemas
                  </span>

                  <Button
                    style={{ float: "right", marginLeft: "10px" }}
                    onClick={() => {
                      this.setState({ showmodal: true });
                    }}
                    color="primary"
                  >
                    Add New
                  </Button>
                </div>
                <div style={{ width: "150px", float: "right" }}>
                  <Select
                    clearable={false}
                    placeholder={"filter"}
                    value={this.state.select}
                    onChange={this.handleSelect}
                    options={options}
                  />
                </div>
                <div
                  className="ag-theme-material"
                  style={{
                    height: "400px",
                    width: "100%",
                    marginTop: "50px"
                  }}
                >
                  <AgGridReact
                    showDeleteIcon={this.state.showDeleteIcon}
                    enableSorting={true}
                    enableFilter={true}
                    onGridReady={this.onGridReady.bind(this)}
                    columnDefs={this.state.columnDefs}
                    rowData={this.state.rowData}
                    rowSelection="single"
                    context={this.state.context}
                    frameworkComponents={this.state.frameworkComponents}
                  />
                </div>

                <ModalComp
                  isOpen={this.state.showmodal}
                  toggle={this.toggle}
                  allSchemas={this.props.allSchemas}
                  {...this.props}
                />

                <Modal
                  open={this.state.deleteModalOpen}
                  onClose={()=> this.setState({deleteModalOpen:false})}
                >
                  <p >Add new asset scheme</p>

                  <div>
                    <Button color="primary" onClick={()=>{
                      this.onRemoveSelected(this.state.deleteSchemaId);
                      this.setState({deleteSchemaId:-1,deleteModalOpen:false})
                    }}>
                      Add
                    </Button>{" "}
                    <Button color="secondary" onClick={()=> this.setState({deleteModalOpen:false})}>
                      Cancel
                    </Button>
                  </div>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    allSchemas: state
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    {
      getAssetsSchemas,
      getContractSchemas,
      getEpcSchemas,
      deleteSchemas,
      getSchemas
    }
  )(Tables)
);



// WEBPACK FOOTER //
// ./src/views/AssetSchemas/AssetSchemas/Table.js